import React from "react";
import styles from "./HeaderTitle.module.sass";
import { SovosTypography, SovosBox } from "mosaic-react";
import { useTheme } from "mosaic-react/styles";
const HeaderTitle = props => {
  const {
    backgroundColor = "grey.50",
    textColor = "primary",
    overTitle,
    children
  } = props;
  const theme = useTheme();
  const colorSplit = backgroundColor.split(".");
  let divBackgroundColor = backgroundColor;
  if (colorSplit?.length > 1) {
    divBackgroundColor = theme.palette[colorSplit[0]][colorSplit[1]];
  }
  const divTextColor = theme.palette.text[textColor] ?? textColor;
  return /*#__PURE__*/React.createElement(SovosBox, {
    className: `${styles["header-title-container"]}`,
    style: {
      backgroundColor: divBackgroundColor
    }
  }, /*#__PURE__*/React.createElement(SovosTypography, {
    sx: {
      color: divTextColor,
      fontWeight: "400"
    },
    variant: "h6"
  }, overTitle), /*#__PURE__*/React.createElement(SovosTypography, {
    sx: {
      color: divTextColor,
      fontWeight: "500",
      fontSize: "1.25rem"
    },
    variant: "h4"
  }, children));
};
export default HeaderTitle;